export const GameStatus = {
	PLANNED: 0,
	LIVE: 1,
	ENDED: 2,
} as const;
